import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class TablenewrowService {

  constructor(private http: HttpClient) { }

  updateEntry(request: any, service_uri: string){
    return this.http.post<any>(`${ environment.apiUrl }${service_uri}`, request);
  }
}